import { useFiltersStore } from '#stores/filters.store';
import { useUserStore } from '#stores/user.store';
import { PermissionService } from '@carrefour-gcs/shared';
import { createGlobalState } from '@vueuse/core';
import { storeToRefs } from 'pinia';
import { computed, type ComputedRef } from 'vue';

export const usePermissions = createGlobalState(() => {
  const userStore = useUserStore();
  const { scope, defaultKpisPerimeter } = storeToRefs(userStore);

  const filtersStore = useFiltersStore();
  const { filters } = storeToRefs(filtersStore);
  const isReady = computed(() => scope.value !== null);

  const permissionService = computed(
    () =>
      new PermissionService({
        userScope: scope?.value ?? undefined,
        selectedFilters: filters.value?.selectedFilters ?? defaultKpisPerimeter.value.filters,
        storePerimeter: filters.value?.storePerimeter ?? defaultKpisPerimeter.value.storePerimeter,
        taxonomy: filters.value?.taxonomy ?? defaultKpisPerimeter.value.taxonomy
      })
  );

  // Create an object of computed values from all permissions defined in PermissionService
  return {
    isReady,
    ...(Object.fromEntries(
      Object.getOwnPropertyNames(Object.getPrototypeOf(permissionService.value))
        .filter((key): key is keyof PermissionService => key !== 'constructor')
        .map((key) => [key, computed(() => permissionService.value[key]())])
    ) as { [K in keyof PermissionService]: ComputedRef<ReturnType<PermissionService[K]>> })
  };
});
